export const NATIONALITIES = [
  {
    code: 'BR',
    name: 'Brasil',
    nationality: 'Brasileiro'
  }
]
